import { setAuthState } from './slices/AuthSlice'

// The backend names its build on every response (X-Gatewatcher-Version; its CORS config exposes the
// header). auth.backendVersion otherwise comes from the login response, and redux-persist keeps it
// until logout, so the header's "API" label went stale after every backend release.
export const VERSION_HEADER = 'X-Gatewatcher-Version'

// Compared with THIS tab's store, never localStorage: redux-persist shares one saved store between
// tabs, so another tab may already have saved the new version while this one still shows the old.
// Only a logged-in tab updates; the login response itself sets the version through login().
export const noteBackendVersion = (store, response) => {
  const headers = response && response.headers
  const version = headers && typeof headers.get === 'function' ? headers.get(VERSION_HEADER) : null
  if (!version) return
  const { auth } = store.getState()
  if (auth.isLoggedIn && auth.backendVersion !== version) {
    store.dispatch(setAuthState({ field: 'backendVersion', value: version }))
  }
}

// The admin calls the API with raw fetch from dozens of places, so wrap fetch once at startup
// rather than each caller. Only responses carrying the header (the GateWatcher backend's) count;
// failures pass through untouched.
export const watchBackendVersion = (store, target = window) => {
  const original = target.fetch
  if (typeof original !== 'function' || original.watchesBackendVersion) return
  const watched = (...args) => original.apply(target, args).then(response => {
    try { noteBackendVersion(store, response) } catch (error) { console.warn('[backendVersion]', error) }
    return response
  })
  watched.watchesBackendVersion = true
  target.fetch = watched
}
